import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { ProcessName, RegisterStartProcess, RegisterCompletedProcess } from '../../../../../global/helpers/analytics-helper';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { useLockedPageState } from '../../../../../global/hooks/useLockedPageState';
import { ApiStatuses } from '../../../../../global/models/api-model';
import { LockedPageKeys } from '../../../../../global/models/locked-page-model';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { FormTypes } from '../../../../account-info/models/form-models';
import { ArcRoutes } from '../../../constants/routes';
import { EmploymentState } from '../../employment/employment-model';
import { CompensationHistoryState } from '../compensation-history/compensation-history-model';
import { setUpdateCompensationStatus } from '../compensation-history/compensation-history-slice';
import { OneTimePaymentForm } from './one-time-payment-form';
import { OneTimePaymentFormValues } from './one-time-payment-form-model';
import { oneTimePayment } from './one-time-payment-requests';

export function OneTimePayment() {
    const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
    const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
    const compensationState = useSelector<TcsmStates, CompensationHistoryState>(state => state.compensationHistoryState);
    const basePath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.Compensation}`);
    const history = useHistory();
    const dispatch = useDispatch();
    const employmentPage = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.Employment}`);

    const lockedState = useLockedPageState(LockedPageKeys.Compensation);

    RegisterStartProcess(ProcessName.OneTimePayment);

    useEffect(() => {
        dispatch(apiErrorClear());
        dispatch(setUpdateCompensationStatus(ApiStatuses.None));
    }, []);

    const onSubmit = (savedValues: OneTimePaymentFormValues, formValues: OneTimePaymentFormValues) => {
        oneTimePayment(dispatch, employmentState?.currentEmployee?.id, employmentState?.currentEmployment?.id, savedValues, formValues);
        RegisterCompletedProcess(ProcessName.OneTimePayment);
    };


    if (lockedState.isLocked) {
        history.push(employmentPage);
    }

    // redirect to individual compensation page on success with query string
    if (compensationState?.updateCompensationStatus === ApiStatuses.Success) {
        return (<Redirect to={{
            pathname: `${basePath}`,
            search: `?success=${FormTypes.COMPENSATION}`,
        }} />);
    }

	return (
		<>
            <OneTimePaymentForm
                formHeader={epiProps.compensationSettingsState.epiContent.oneTimePaymentPageTitle}
                formDescription={epiProps.compensationSettingsState.epiContent.oneTimePaymentDescription }
                onSubmitHandler={(initialValues: OneTimePaymentFormValues, formValues: OneTimePaymentFormValues) => onSubmit(initialValues, formValues) }
                compensationProps={epiProps?.compensationSettingsState?.epiContent}
                labelSettings={epiProps?.labelSettingState?.epiContent}
                previousRoute={basePath}
            />

		</>
	);
}